import type { PaginatedParams, SearchParams, ListParams } from "./types";

export function buildPaginatedUrl(base: string, params?: PaginatedParams, extraParams?: Record<string, string | string[]>): string {
  const searchParams = new URLSearchParams();
  if (params?.page !== undefined) searchParams.set("page", String(params.page));
  if (params?.perPage !== undefined) searchParams.set("perPage", String(params.perPage));
  if (params?.sort) searchParams.set("sort", params.sort);
  if (params?.order) searchParams.set("order", params.order);
  if (params?.category) searchParams.set("category", params.category);
  if (extraParams) {
    for (const [key, value] of Object.entries(extraParams)) {
      if (Array.isArray(value)) {
        for (const v of value) {
          searchParams.append(key, v);
        }
      } else {
        searchParams.set(key, String(value));
      }
    }
  }
  const query = searchParams.toString();
  return query ? `${base}?${query}` : base;
}

export function buildSearchUrl(base: string, params?: SearchParams): string {
  const searchParams = new URLSearchParams();
  if (params?.q) searchParams.set("q", params.q);
  if (params?.page !== undefined) searchParams.set("page", String(params.page));
  if (params?.perPage !== undefined) searchParams.set("perPage", String(params.perPage));
  if (params?.sort) searchParams.set("sort", params.sort);
  if (params?.order) searchParams.set("order", params.order);
  if (params?.filters) {
    for (const [key, value] of Object.entries(params.filters)) {
      searchParams.set(`filters[${key}]`, value);
    }
  }
  const query = searchParams.toString();
  return query ? `${base}?${query}` : base;
}

export function buildListUrl(base: string, params?: ListParams): string {
  const searchParams = new URLSearchParams();
  if (params?.page !== undefined) searchParams.set("page", String(params.page));
  if (params?.perPage !== undefined) searchParams.set("perPage", String(params.perPage));
  if (params?.sort) searchParams.set("sort", params.sort);
  if (params?.order) searchParams.set("order", params.order);
  if (params?.category) searchParams.set("category", params.category);
  if (params?.search) searchParams.set("search", params.search);
  if (params?.filters) {
    for (const [key, value] of Object.entries(params.filters)) {
      searchParams.set(`filters[${key}]`, value);
    }
  }
  const query = searchParams.toString();
  return query ? `${base}?${query}` : base;
}
